var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex',{staticClass:"g-icon-component",class:_vm.classes,style:(_vm.styles),attrs:{"align-items":""},on:{"click":function($event){_vm.button && _vm.$emit('click')}}},[_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }